import React, { useCallback } from 'react'
import { IMemberBenefit } from '@verzekeringapp-mono/shared/src/models/member_benefit'
import useMemberBenefits from '@verzekeringapp-mono/shared/src/hooks/use_member_benefits'
import copy from 'copy-to-clipboard'
import Modal from '~/components/Modal'
import SuccessSvg from '~/components/illustrations/Succes'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getIsMemberBenefitLoading } from '@verzekeringapp-mono/shared/src/state/selectors/member_benefits'
import LoadingIndicator from '~/components/LoadingIndicator'

interface IProps {
  memberBenefit: IMemberBenefit
}

const MemberBenefitVoucher: React.FC<IProps> = ({ memberBenefit }) => {
  const [openIsCopiedModal, setOpenIsCopiedModal] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState<string | null>(null)

  const { getDiscountCode } = useMemberBenefits()

  const isLoading = useAppSelector(getIsMemberBenefitLoading)

  const copyDiscountCode = () => {
    if (!memberBenefit?.discountCode) return
    copy(memberBenefit?.discountCode ?? '')

    setOpenIsCopiedModal(true)
    setTimeout(() => {
      setOpenIsCopiedModal(false)
    }, 1000)
  }

  const handleOnPress = useCallback(() => {
    if (memberBenefit?.discountCode) {
      copyDiscountCode()
    } else {
      getDiscountCode(`${memberBenefit.id}`).catch((error) => {
        setErrorMessage(error.message || 'Er is iets misgegaan bij het ophalen van de kortingscode, probeer het opnieuw.')
      })
    }
  }, [memberBenefit])

  if (memberBenefit.memberBenefitType !== 'Kortingscode') {
    return null
  }

  return (
    <div>
      {!isLoading && !errorMessage && (
        <button
          className={'mt-4 mb-6 w-full rounded-md bg-action-primary-background text-action-primary-foreground'}
          disabled={isLoading || !!errorMessage}
          onClick={handleOnPress}
        >
          <div>
            {
              memberBenefit?.discountCode && (
                <div>
                  <p className='text-action-primary-foreground'>Je kortingscode:</p>

                  <span className='text-xl font-medium text-action-primary-foreground'>
                    {memberBenefit.discountCode}
                  </span>

                  <p className='text-action-primary-foreground'>
                    Klik op de knop om de code te kopiëren
                  </p>
                </div>
              )
            }

            {
              !memberBenefit?.discountCode && (
                <p className='py-4 text-action-primary-foreground'>
                  Code genereren
                </p>
              )
            }

          </div>
        </button>
      )}

      {errorMessage && (
        <div className='mb-6'>
          <p>
            {errorMessage}
          </p>
        </div>
      )}

      {isLoading && (
        <div className='mb-6'>
          <LoadingIndicator />
        </div>
      )}

      {openIsCopiedModal && (
        <Modal onClose={() => setOpenIsCopiedModal(false)}>
          <div className='flex flex-col items-center justify-center'>
            <SuccessSvg />

            <p className='text-center text-2xl'>Gekopieerd naar klembord</p>
          </div>
        </Modal>
      )}
    </div>
  )
}

export default MemberBenefitVoucher
